<template>
  <section class="title-dialog" v-if="isTitleShow">
      <div class="dialog-content">
          <div class="dialog-info">
              <p class="title">声明</p>
              <p>本服务由上海盛世大联汽车服务股份有限公司提供，相关责任由该公司承担。我行将在法律法规和合同约定范围内合规开展经营活动，维护客户信息安全，保护消费者合法权益。</p>
              <div class="tip">
                  <img class="change" :src="change?img01:img02" mode="widthFix"  @click="changeState"/>
                  <p>跳转此服务后30日内不再提示</p>
              </div>
          </div>
          <div class="dialog-btn"  @click="handleConfirm">知道了</div>
      </div>
  </section>
</template>

<script>
export default {
    props:{
        isTitleShow:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            change:false,
            img01:require('@/assets/imgs/changed.png'),
            img02:require('@/assets/imgs/state.png'),
        }
    },
    methods:{
        changeState(){
            this.change = !this.change
            console.log(Math.round(new Date()),Math.round(new Date())+3*60*60,'12313');
        },
        handleConfirm(){
            this.$emit('update:isTitleShow',false)
            if (this.change) {
                let date = Math.round(new Date()) + 30 * 24 * 60 * 60 * 1000;
                localStorage.setItem('dialogDate',date)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.title-dialog{
    position: fixed;
    display: flex;
    align-items: flex-end;
    // justify-content: center;
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 0;
    background: rgba(1,1,1,0.6);
    .dialog-content{
        width: 100%;
        background: #ffffff;
        margin: 0 auto;
        .dialog-info{
            padding: 18px 25px 20px;
            border-bottom: 1px solid #E5E5E5;
            text-align: left;
            .record-icon{
                width: 60px;
                height: 60px;
                margin-bottom: 20px;
            }
            
            .title{
                text-align: center;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .tip{
                display: flex;
                margin-top: 20px;
                font-size: 11px;
                .change{
                    width: 16px;
                    height: 16px;
                }
                p{
                    margin-left: 5px;
                }
            }
        }
        .dialog-btn{
            text-align: center;
            font-size: 16px;
            background-color: #16A085;
            color: #FFFFFF;
            height: 55px;
            line-height: 55px;
        }
    }
}
</style>